import {dialogApi} from '../../../../../api/dialogApi'
import styles from './SentimentCard.module.scss'
import {WuCard, WuCardHeader, WuHeading} from '@npm-questionpro/wick-ui-lib'
import {useMemo, useState} from 'react'
import {SentimentModal} from './SentimentModal/SentimentModal'
import {useParams} from 'react-router'
import {useWt} from '@npm-questionpro/wick-ui-lib'
import {DIALOG} from '../../../../../Translation/English/dialog'
import type {IDialogSentimentBucket} from '../../../../../types/dialogTypes'

export const SentimentCard: React.FC = () => {
  const wt = useWt()
  const [showSentimentModal, setShowSentimentModal] = useState<boolean>(false)
  const [selectedSentiment, setSelectedSentiment] =
    useState<IDialogSentimentBucket | null>(null)
  const {dialogId} = useParams<{dialogId: string}>()
  const {data: analyticsData} = dialogApi.useDialogAnalytics(dialogId ?? '')

  const colours: Record<string, string> = useMemo(
    () => ({
      negative: '#F85271',
      neutral: '#F1DA7E',
      positive: '#42BD84',
    }),
    [],
  )

  return (
    <>
      <WuCard rounded>
        <WuCardHeader className={styles.cardHeading}>
          <WuHeading size="sm">{wt(DIALOG.overallSentiment)}</WuHeading>
        </WuCardHeader>
        <div className={styles.sentimentCard}>
          <div className={styles.sentimentCardBar}>
            {analyticsData?.sentiment?.map(item => (
              <>
                {item.percentage > 0 && (
                  <div
                    key={item.type}
                    onClick={() => {
                      setSelectedSentiment(item)
                      setShowSentimentModal(true)
                    }}
                    style={{
                      width: `${item.percentage}%`,
                      backgroundColor: colours[item.type.toLowerCase()],
                    }}
                  >
                    <span className={styles.sentimentCardPerc} data-i18n-skip>
                      {item.percentage}%
                    </span>
                  </div>
                )}
              </>
            ))}
          </div>

          <div className={styles.sentimentCardLegendBlock}>
            {analyticsData?.sentiment?.map(item => (
              <div key={item.type} className={styles.sentimentCardLegendItem}>
                <div
                  className={styles.sentimentCardLegend}
                  style={{
                    backgroundColor: colours[item.type.toLowerCase()],
                  }}
                />
                <span>{item.type}</span>
              </div>
            ))}
          </div>
        </div>
      </WuCard>
      {showSentimentModal && (
        <SentimentModal
          showModal={showSentimentModal}
          closeModal={() => {
            setShowSentimentModal(false)
            setSelectedSentiment(null)
          }}
          data={selectedSentiment}
        />
      )}
    </>
  )
}
